(function (window: any) {
    function createHttpRequest() {
        if (window['ActiveXObject']) {
            //@ts-expect-error: xx
            return new ActiveXObject("Microsoft.XMLHTTP");
        }
        else if (window.XMLHttpRequest) {
            return new XMLHttpRequest();
        }
    }
    function AliLogTracker(this: any, host: any, project: any, logstore: any) {
        const that = this as any;
        that.uri_ = 'https://' + project + '.' + host + '/logstores/' + logstore + '/track?APIVersion=0.6.0';
        that.params_ = new Array<any>();
        that.httpRequest_ = createHttpRequest();
    }
    AliLogTracker.prototype = {
        push: function (key: string, value: string) {
            if (!key || !value) {
                return;
            }
            this.params_.push(key);
            this.params_.push(value);
        },
        logger: function () {
            let url = this.uri_;
            let k = 0;
            while (this.params_.length > 0) {
                if (k % 2 == 0) {
                    url += '&' + encodeURIComponent(this.params_.shift());
                }
                else {
                    url += '=' + encodeURIComponent(this.params_.shift());
                }
                ++k;
            }
            try {
                this.httpRequest_.open("GET", url, true);
                this.httpRequest_.send(null);
            }
            catch (ex) {
                if (window && window.console && typeof window.console.log === 'function') {
                    console.log("Failed to log to ali log service because of this exception:\n" + ex);
                    console.log("Failed log data:", url);
                }
            }

        }
    };
    window['Tracker'] = AliLogTracker;
})(window);

export interface SLogParams {
    /** 场景 */
    wxscene?: string,
    /** 归因 */
    cid?: string,
    /** 归因参数 */
    at?: string,
    /** 归因参数 */
    st?: string,
    /** App版本号 */
    v?: string,
    /** 用户uid */
    uid?: string,
    /** 用户机型参数 */
    useragent?: string,
    /** 用户创建时间 */
    ct?: number,
    cv?: string,
    lt?: any,
    dt?: any,
    did?: string,
}

class SLog {

    private static instance: SLog = null!;

    private gameId!: string;

    private host!: string;
    private project!: string;
    private logstore!: string;

    public cid: string = null!;
    public uid: string = null!;
    //最后归因成功时间
    public at: string = null!;
    //点击链接访问时间
    public st: string = null!;
    public v: string = "26.1.7";
    public ct: string = '0';
    public lt: string = '0';
    public dt: string = '0';
    public fu: string = '0';
    public did: string = '0';
    public useragent: string = null!;
    public wxscene: string = "0";
    private extraParam: any = {};

    public localUuid: string = "0";

    private constructor() { }

    public static getInstance(): SLog {
        if (this.instance == null) {
            this.instance = new SLog();
        }
        return this.instance;
    }

    public initSLog(gameId: string, host: string = "cn-shenzhen.log.aliyuncs.com", project: string = 'qianlu-log', logstore: string = 'log'): void {
        this.gameId = gameId;
        this.host = host;
        this.project = project;
        this.logstore = logstore;
        // console.log("SLog init", this.gameId, this.host, this.project, this.logstore);
    }

    public initParams(obj?: SLogParams, userInfo?: any) {
        if (!obj) {
            obj = {};
        }
        console.log("SLog initParams", userInfo);
        if (userInfo) {
            const user = {
                uid: userInfo.uuid,
                cid: userInfo.extra_data?.sfrom ?? "0",
                useragent: navigator.userAgent,
                ct: userInfo.create_time,
            }
            obj = Object.assign(obj, user);
        }
        const that = this as any;
        const keys = Object.keys(obj) as Array<keyof SLogParams>;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = obj[key];
            if (Object.prototype.hasOwnProperty.call(that, key)) {
                if (value) {
                    that[key] = value;
                } else {
                    console.log("SLog 参数为空不赋值：" + keys[i]);
                }
            } else {
                console.error("SLog 不存在对象：" + keys[i], this);
                break;
            }
        }
    }

    //设置额外参数
    public setExtraParams(key: string, value: string) {
        if (key) {
            this.extraParam[key] = value;
        }
    }

    public setSLogLoginParams(cid: string, uid: string, ct: string, fu: string) {
        this.cid = cid ? cid : "0";
        this.uid = uid ? uid : "0";
        this.ct = ct ? ct : "0";
        this.fu = fu ? fu : "0";
    }

    public setLTDT(lt: string, dt: string) {
        this.lt = lt;
        this.dt = dt;
    }

    /** 设置设备id */
    public setDid(did: string) {
        this.did = did;
    }

    public setCid(cid: string) {
        if (!cid || cid == '' || cid == '0') {
            console.log("cocos reciver fail cid=>" + cid);
            return true;
        }
        this.cid = cid;
        if (!this.gameId || !this.host || !this.project || !this.logstore) {
            return false;
        }
        return true;
    }
    public setAT(at: string) {
        if (!at || at == '' || at == '0') {
            console.log("cocos reciver fail at=>" + at);
            return true;
        }
        this.at = at;
        if (!this.gameId || !this.host || !this.project || !this.logstore) {
            return false;
        }
        return true;
    }
    public setST(st: string) {
        if (!st || st == '' || st == '0') {
            console.log("cocos reciver fail at=>" + st);
            return true;
        }
        this.st = st;
        if (!this.gameId || !this.host || !this.project || !this.logstore) {
            return false;
        }
        return true;
    }

    public getCt() {
        return this.ct || 0;
    }

    public getCid() {
        return this.cid || 0;
    }

    public logEvent(e: string, ev = '', map: { [k: string]: any } | null = null) {
        if (import.meta.env.VITE_SERVER_TEST) {
            console.log("%c[SLog]%c%s", "color:#ffffff;background:#008080;font-size:1.2em;padding:0.2em;", "background:#74b9ff;font-size:1.2em;padding:0.2em;", `e:${e}${ev && ev != "" ? " ev:" + ev : ""}`);
        }
        console.log("SLog", this.gameId, this.host, this.project, this.logstore);

        if (!this.gameId || !this.host || !this.project || !this.logstore) {
            console.warn("SLog 配置出错: ", e, ev);
            return;
        }

        const event: { [k: string]: any } = {
            "gameid": this.gameId,
            "cid": this.cid,
            "v": this.v ? this.v : "0",
            "uid": this.uid ? this.uid : "0",
            "ct": this.ct ? this.ct : "0",
            // "lt": this.lt ? this.lt : "0",
            "dt": this.dt ? this.dt : "0",
            "fu": this.fu && this.fu != 'null' ? this.fu : '0',
            "did": this.did || "0",
            "ua": this.useragent,
            "wxscene": this.wxscene,
            "e": e,
            "ev": ev,
            "at": this.at,
            "st": this.st,
        };

        //新增额外参数
        if (this.extraParam) {
            Object.assign(event, this.extraParam);
        }

        if (map) {
            const keys = Object.keys(map);
            keys.forEach(key => {
                if (!Object.prototype.hasOwnProperty.call(event, key)) {
                    event[key] = map[key];
                }
            })
        }

        const logger = new ((window as any)['Tracker'])(this.host, this.project, this.logstore);
        Object.keys(event).forEach(key => {
            logger.push(key, event[key]);
        });
        logger.logger();
    }

    /**
     * 将捕获到的异常上报到阿里日志
     * @param action 报错类型，拼接在ev的前缀
     * @param error 错误对象
     */
    public errorEvent(action: string, error: Error) {
        if (!error) return;
        let str = action + "->";
        if (error.stack) {
            try {
                const strArr = error.stack.split('\n', 3);
                str += `${strArr[0]} ->${strArr[1].replace(/\s+/, ' ')}`;
            } catch (error: any) { str += `${error.name}:${error.message}`; }
        } else {
            str += `${error.name}:${error.message}`;
        }
        this.logEvent('cocos_error', str);
    }
}

export default SLog.getInstance();
